import {ImageVM} from "./ImageVM.model";
import {PriceInfoDetailVM} from "./PriceInfoDetailVM.model";
import {ServiceOptionVM} from "./ServiceOptionVM.model";
import {TotalPriceVM} from "./TotalPriceVM.model";
import {PersonInfoVM} from "./PersonInfoVM.model";
import {ServiceItemVM} from "./ServiceItemVM";
import {SessionTimeVM} from "./SessionTimeVM.model";
import {ParticipantVM} from "./ParticipantVM.model";

/**
 * Created by saeed on 12/29/2016.
 */

export class OrderBagItemVM {
  id:number;
  orderBagServiceItemDtail:OrderBagItemDetailVM[];
  options:ServiceOptionVM[];
  totalPrice:TotalPriceVM;
  participantPersons:ParticipantVM[];
  serviceItem:any;
  timeSession:SessionTimeVM;
  serviceItemId:number;
  index:number = 0;
  servant:any;
  servantId:number;


  constructor() {

  }
}
export class OrderBagItemDetailVM {
  id:number;
  gty:number = 0;
  priceInfoDtailId:number;
  timeUnitQty:number;
  priceInfoDtail:PriceInfoDetailVM;

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/models/OrderBagItemVM.model.ts